module.exports = __webpack_public_path__ + "img/banner_our_offering_04.01351a37.png";